import { Controller } from "@hotwired/stimulus"
import axios from 'axios';

export default class extends Controller {
  static targets = ["tableView", "toggleButton", "filteredCount", "applicationsCount", "categoryQuery", "customerTypeQuery", "availableAtQuery", "sortHeader", "clearAllButton", "clearAllCount", "quickSortButton", "quickSortRemove"]
  static values = { apartmentId: Number }
  filteredCache = null;
  unfilteredCache = null;
  filteredOutCount = 0;
  filteredApplicationsCount = 0;
  allApplicationsCount = 0;
  isFiltered = true;
  params = {};
  sortOrder = [];

  connect() {
    this.load()
  }

  async load() {
    await this.fetchData(this.buildParams());
    this.render();
  }

  render() {
    if (this.hasFilteredCountTarget) {
      this.filteredCountTarget.innerHTML = this.filteredOutCount;
    }
    if (this.isFiltered) {
      this.tableViewTarget.innerHTML = this.filteredCache;
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.innerHTML = "<i class='fa fa-toggle-off'></i><span>Näytä</span>";
      }
      if (this.hasApplicationsCountTarget) {
        this.applicationsCountTarget.innerHTML = this.filteredApplicationsCount + " hakijaa";
      }
    } else {
      this.tableViewTarget.innerHTML = this.unfilteredCache;
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.innerHTML = "<i class='fa fa-toggle-on'></i> <span>Näytä</span>";
      }
      if (this.hasApplicationsCountTarget) {
        this.applicationsCountTarget.innerHTML = this.allApplicationsCount + " hakijaa";
      }
    }
  }

  async fetchData(params) {
    this.tableViewTarget.innerHTML = "<div>Ladataan...</div>"
    const response = await axios.get(`/admin/apartments/${this.apartmentIdValue}/active_applications/application_stack.json`, { params });
    if (response.status === 200) {
      this.filteredCache = response.data.filtered_html;
      this.unfilteredCache = response.data.html;
      this.filteredApplicationsCount = response.data.filtered_applications_count;
      this.allApplicationsCount = response.data.all_applications_count;
      this.filteredOutCount = response.data.filtered_out_count;
    }
  }

  toggleFilter() {
    this.isFiltered = !this.isFiltered;
    this.render();
  }

  async applyQueries() {
    this.updateParams({
      category: this.categoryQueryTarget.value,
      customer_type: this.customerTypeQueryTarget.value,
      available_at: this.availableAtQueryTarget.value
    });

    await this.fetchData(this.buildParams());
    this.render();
  }

  async sortColumns(event) {
    const column = event.currentTarget.dataset.columnName
    const existing = this.sortOrder.find(s => s.column === column)

    if (existing) {
      existing.direction = existing.direction === 'asc' ? 'desc' : 'asc'
    } else {
      this.sortOrder.push({ column, direction: 'asc' })
    }

    await this.fetchData(this.buildParams());
    this.render();
    this.updateSortUI();
  }

  async quickSort() {
    this.sortOrder = [{ column: 'needed_by', direction: 'asc' }]

    await this.fetchData(this.buildParams());
    this.render();
    this.updateSortUI();
  }

  async removeSortCriteria(event) {
    event.stopPropagation()
    const column = event.currentTarget.dataset.columnName
    this.sortOrder = this.sortOrder.filter(s => s.column !== column)

    await this.fetchData(this.buildParams());
    this.render();
    this.updateSortUI();
  }

  async clearAllSorts(event) {
    event.preventDefault()
    this.sortOrder = []

    await this.fetchData(this.buildParams());
    this.render();
    this.updateSortUI();
  }

  updateSortUI() {
    this.sortHeaderTargets.forEach(header => {
      const column = header.dataset.columnName
      const sortIcon = header.querySelector('.sort-icon')
      const sortChip = header.querySelector('.sort-chip')
      const badge = header.querySelector('.sort-badge')
      const sortIndex = this.sortOrder.findIndex(s => s.column === column)

      if (sortIndex >= 0) {
        header.classList.add('sort-active')
        header.dataset.sortDirection = this.sortOrder[sortIndex].direction
        if (sortIcon) sortIcon.style.display = 'none'
        if (sortChip) sortChip.style.display = ''
        if (badge) badge.textContent = sortIndex + 1
      } else {
        header.classList.remove('sort-active')
        delete header.dataset.sortDirection
        if (sortIcon) sortIcon.style.display = ''
        if (sortChip) sortChip.style.display = 'none'
      }
    })

    if (this.hasQuickSortButtonTarget) {
      const quickSortActive = this.sortOrder.some(s => s.column === 'needed_by')
      this.quickSortButtonTarget.classList.toggle('active', quickSortActive)
      if (this.hasQuickSortRemoveTarget) {
        this.quickSortRemoveTarget.style.display = quickSortActive ? '' : 'none'
      }
    }

    if (this.hasClearAllButtonTarget) {
      this.clearAllButtonTarget.classList.toggle('disabled', this.sortOrder.length === 0)
      if (this.hasClearAllCountTarget) {
        this.clearAllCountTarget.textContent = `(${this.sortOrder.length})`
      }
    }
  }

  updateParams(newParams) {
    Object.assign(this.params, newParams);
  }

  buildParams() {
    const params = { ...this.params }
    if (this.sortOrder.length > 0) {
      const sortParams = Object.fromEntries(this.sortOrder.map(s => [s.column, s.direction]))
      params.sort_columns = JSON.stringify(sortParams)
    } else {
      delete params.sort_columns
    }
    return params
  }
}
